type Video = {
  videoId: string;
  thumbnail: string | null;
};

type VideoInfoBoxProps = {
  videos: Video[];
  message: string;
};

export const VideoInfoBox = ({ videos, message }: VideoInfoBoxProps) => {
  const displayThumbnails = videos.slice(0, 2);
  const count = videos.length;

  return (
    <div className="flex items-center gap-3 rounded-lg bg-muted p-3">
      {/* Stacked thumbnail group */}
      <div className="flex items-start">
        {displayThumbnails.map((video) => (
          <div
            key={video.videoId}
            className="border border-black/[0.08] rounded size-10 -mr-3 overflow-hidden shrink-0"
          >
            {video.thumbnail ? (
              <img src={video.thumbnail} alt="" className="size-full object-cover" />
            ) : (
              <div className="size-full bg-quaternary" />
            )}
          </div>
        ))}
        {/* Count badge */}
        <div className="bg-primary border border-secondary rounded size-10 flex items-center justify-center shrink-0">
          <span className="text-quaternary text-base font-semibold">{count}</span>
        </div>
      </div>

      {/* Description text */}
      <p className="text-sm font-medium text-muted-foreground flex-1">{message}</p>
    </div>
  );
};
